import {createHistory} from '@daedalus/core/src/utils/history/createHistory'
import Settings from 'Settings'

export const history = createHistory({basename: Settings.get('PUBLIC_URL')})
